// ---------------------------------------------------------------------------
// tRPC HTTP 배치 전송 한계 — 서버(apps/api 의 createExpressMiddleware maxBatchSize)와
// 클라이언트(web·admin httpBatchLink 의 maxItems·maxURLLength)가 같은 값을 쓴다.
// 서버 상한만 두면 같은 틱에 상한을 넘게 묶인 호출이 통째로 400 이 되므로 클라이언트도 같은 값으로 나눈다.
// ---------------------------------------------------------------------------

/**
 * 한 HTTP 요청에 묶는 프로시저 호출 수 상한. /trpc IP 레이트리밋은 HTTP 요청 단위로 세므로,
 * 상한이 없으면 배치 하나로 수백 호출을 실어 레이트리밋을 우회하고 DB 풀을 오래 쥘 수 있다.
 * 지금 화면 중 한 틱에 가장 많이 묶는 어드민 상품 편집(7건)보다 넉넉하다. 넘더라도 클라이언트 maxItems 가
 * 같은 값으로 나눠 보내므로 400 이 나지 않는다.
 */
export const TRPC_MAX_BATCH_SIZE = 10;

/**
 * 같은 틱 GET 병합의 URL 길이 상한(오리진 포함). nginx 기본 요청줄 버퍼(8k)·CloudFront URL 상한(8192바이트)보다
 * 여유 있게 작고, 단건 최대(고객 이미지 표시 URL 갱신 100개 ≈ 4.6KB, 면 사진 표시 URL 갱신
 * MAX_FACE_PHOTO_URL_KEYS 키 ≈ 2.5KB)보다 크다 — 링크는 이 길이를 넘기 전에 요청을 나누고,
 * 이보다 긴 단건은 보내지 않고 거부한다.
 */
export const TRPC_MAX_URL_LENGTH = 6000;
